module.exports = __webpack_public_path__ + "img/a4.2966ab8e.jpg";